<template>
  <div class="">
    <v-text-field
      v-model="searchTxt"
      clearable
      outlined
      dense
      hide-details
      placeholder="search"
      color="primary"
      class="screener-input"
      append-icon="mdi-magnify"
      v-if="!og.dynamic"
    ></v-text-field>
    <v-checkbox
      dense
      color="primary"
      v-model="cb.selected"
      hide-details
      v-for="cb in checkboxes"
      :key="cb.refId"
      @click="toggleCheckBox(cb)"
      :disabled="cb.disabled"
    >
      <template v-slot:label>
        {{ cb.name }} <v-spacer></v-spacer>
        <span>({{ cb.count }})</span>
        <span
          v-if="og.dynamic"
          class="pl-2"
          @click.stop.prevent="editStockUniverse(cb)"
          ><v-icon>mdi-square-edit-outline</v-icon></span
        >
      </template>
    </v-checkbox>
    <div class="pa-1" v-if="enableShowMore">
      <a @click="toggleShowMore()" v-if="showMore"> Show more</a>
      <a @click="toggleShowMore()" v-else> Show less</a>
    </div>

    <v-dialog
      v-if="og.dynamic"
      max-width="500px"
      v-model="openStockUniverse"
      scrollable
      persistent
    >
      <StockUniverse
        :ogId="og.refId"
        :open.sync="openStockUniverse"
        :codes="selectedCb.value"
        :cbId="selectedCb.refId"
        @update="updateStockUniverse"
        @removeCb="removeCb"
        :cb="selectedCb"
        editMode
      />
    </v-dialog>
  </div>
</template>

<style scoped>
.v-input--selection-controls {
  margin-top: 5px;
}
</style>

<script>
import StockUniverse from "@/components/filter/StockUniverse";
export default {
  name: "CheckBox",
  props: {
    og: { type: Object, required: true },
  },
  components: { StockUniverse },
  data: () => ({
    limit: 10,
    showMoreCount: 10,
    showMore: false,
    searchTxt: null,
    openStockUniverse: false,
    selectedCb: {},
  }),
  methods: {
    toggleShowMore() {
      this.showMore = !this.showMore;
      if (this.showMore) {
        this.limit = this.showMoreCount;
        return;
      }
      this.limit = this.count ? this.count : 10;
    },
    toggleCheckBox(cb) {
      this.searchTxt = "";
      // this.og.showClearOption = this.enableClear;
      this.$emit("applyFilter", {
        id: this.og.refId,
        action: this.og.refId === "STOCK_UNIVERSE" ? "refresh": "",//cb.selected ? "add" : "remove",
        val: cb.value,
        cbId: cb.refId
      });
    },
    editStockUniverse(cb) {
      this.openStockUniverse = true;
      this.selectedCb = cb; // @todo: need to be fetched and send updated
    },
    updateStockUniverse({name, preSelect, codes}) {
      this.selectedCb.value = codes;
      this.selectedCb.name = name;
      this.selectedCb.selected = preSelect;
      this.toggleCheckBox(this.selectedCb);
    },
    removeCb({ cbId }) {
      this.$emit("removeCb", { og: this.og, cbId });
    },
  },
  computed: {
    fCheckboxes() {
      let checkboxes = this.og.checkboxes;
      if (this.searchTxt) {
        checkboxes = checkboxes.filter((cb) => {
          let cbName = cb.name.toUpperCase();
          let searchTxt = this.searchTxt.toUpperCase();
          return cbName.indexOf(searchTxt) > -1;
        });
      }
      return checkboxes;
    },
    count() {
      let c =
        this.og && Array.isArray(this.fCheckboxes)
          ? this.fCheckboxes.filter((cb) => !cb.hide).length
          : 0;
      return c;
    },
    checkboxes() {
      return Array.isArray(this.fCheckboxes) ? this.fCheckboxes.slice(0, this.limit): [];
    },
    enableShowMore() {
      return this.count > this.showMoreCount;
    },
    /*enableClear() {
      let enable =
        this.og && Array.isArray(this.og.checkboxes)
          ? this.og.checkboxes.filter((cb) => cb.selected).length
          : 0;
      return !!enable;
    },*/
  },
  created() {
    this.showMore = this.enableShowMore;
  },
};
</script>
<style>
.custom-checkbox .v-input--selection-controls {
  padding-top: 0px !important;
  padding-bottom: 12px !important;
}

.custom-checkbox .theme--light.v-label {
  color: black;
  font-size: 14px;
  font-family: "Lato-Regular";
}
</style>